import {
  ALV_NOLLAAN_LUKITUT_LAJIT,
  AsiakkaanTuote,
  EI_LASKUNUMEROA_NUMERO,
  EmailLahetysStatus,
  EmailLahetysStatusKoodi,
  Lasku,
  LaskuBase,
  LaskuEmailtyojononMerkinta,
  LaskunAsiakas,
  LaskunLahetystapa,
  LaskunLahetystyyppi,
  LaskunSahkoinenOsoite,
  LaskunSahkpostipohjanVari,
  LaskunTila,
  LaskunToimintalokiSahkoinenParametrit,
  LaskunToimintalokiSpostiParametrit,
  LaskunToimintalokiTilastoParametrit,
  LaskunToimintalokiTyyppi,
  LaskunTuote,
  LaskunTyypit,
  LaskunumeroTyyppi,
  LaskuPerintaEmailtyojononMerkinta,
  LaskuPostgresTyojonoData,
  LaskuReskontra,
  LaskuSahkoinenLahetysStatusKoodi,
  LaskuSahkoinentyojononMerkinta,
  LaskuTasapainoitaJaLahetaTyojonomerkinta,
  LaskuToimintaloki,
  LaskutoimintalokiMerkinta,
  LaskuToimittaja,
  LaskuTulostamistyojononMerkinta,
  LaskuVientiLemonatoriintyojononMerkinta,
  ReplikoiToimittajaTyojonoData,
  TuoteAvaimet,
  TypeaheadAsiakasIlmanAvainta,
  TypeaheadToimittajaIlmanAvainta,
  TypeaheadTuoteIlmanAvainta,
  UUDEN_LASKUN_AVAIN,
} from '../../model/lasku'

import { CurrencyService } from '@lemon/core/service/currency.service'
import { DateService } from '@lemon/core/service/date.service'
import { StringService } from '@lemon/core/service/string.service'
import { TimestampProviderBase } from '@lemon/core/service/timestamp-provider.interface'
import { ViitenumeroService } from '@lemon/core/service/viitenumero.service'
import { TranslationService } from '../translation.service'
import { LaskuChangeCollector, LaskuChangeCollectorInterface, LaskuSharedService, ReskontraService } from './lasku-shared.service'
import { LaskuUriService } from './lasku-uri.service'
import { LaskuIndeksoija } from './lasku.indeksoija'
import { LaskuKopioija } from './lasku.kopioija'

import { Big } from 'big.js'

import { Timestamp } from '@lemon/core/model/common'
import { LaskuHakuindeksiTyojonoMerkinta } from '../../model/hakuindeksi'
import { KayttajanTiedot } from '../../model/kayttaja'
import { LaskuLahetyksenToistoasetukset, ToistuvaLasku } from '../../model/lasku-toistuva'
import { LaskuLahetystietojenLuoja } from './lasku-lahetystietojen.luoja'

export interface JuurilaskuJaKasiteltava {
  juurilasku: Lasku
  kasiteltava: LaskuBase
}

export interface MaksumuistutusSpostiParametrit {
  kayttajanTiedot: KayttajanTiedot
  templateId: number
  juurilaskuOriginal: Lasku
  kasiteltavaOriginal: LaskuBase
  reskontra: LaskuReskontra[]
  vastaanottajat: EmailLahetysStatus[]
  aihe: string
  otsikko: string
  teksti: string
  slogan: string
  paivitaLahettajatAsiakkaaseen: boolean
  batchManipulator?: BatchManipulator
  ostavanAsiakkaanAvain?: string
  allekirjoitusHtml?: string
}

export interface LaskuSpostiParametrit {
  kayttajanTiedot: KayttajanTiedot
  templateId: number
  juurilaskuOriginal: Lasku
  kasiteltavaOriginal: LaskuBase
  reskontra: LaskuReskontra[]
  vastaanottajat: EmailLahetysStatus[]
  aihe: string
  otsikko: string
  teksti: string
  slogan: string
  tasapainoitaEnsinKayttaenViitenumeroa: string
  manipulator?: BatchManipulator
  varit?: { [key in LaskunSahkpostipohjanVari]: string }
  footer?: 'footer1' | 'footer2'
  logoInFooter?: boolean
  lisahuomautus?: string
  ostavanAsiakkaanAvain?: string
}

export interface LaskuTulostusParametrit {
  kayttajanTiedot: KayttajanTiedot
  juurilasku: Lasku
  kasiteltava: LaskuBase
  reskontra: LaskuReskontra[]
  batchManipulator?: BatchManipulator
  tasapainoitaEnsinKayttaenViitenumeroa?: string
  ostavanAsiakkaanAvain?: string
}

export interface LahetaUudelleenSpostillaParametrit {
  kayttajanTiedot: KayttajanTiedot
  templateId: number
  juurilaskuOriginal: Lasku
  kasiteltavaOriginal: LaskuBase
  reskontra: LaskuReskontra[]
  vastaanottajat: EmailLahetysStatus[]
  aihe: string
  otsikko: string
  teksti: string
  slogan: string
  ostavanAsiakkaanAvain?: string
}

export interface LahetaUudelleenSahkoisestiParametrit {
  kayttajanTiedot: KayttajanTiedot
  osoite: LaskunSahkoinenOsoite
  juurilaskuOriginal: Lasku
  kasiteltavaOriginal: LaskuBase
  reskontra: LaskuReskontra[]
  ostavanAsiakkaanAvain?: string
}

export interface LahetaUudelleenTulostamallaParametrit {
  kayttajanTiedot: KayttajanTiedot
  juurilaskuOriginal: Lasku
  kasiteltavaOriginal: LaskuBase
  reskontra: LaskuReskontra[]
  ostavanAsiakkaanAvain?: string
}

/**
 * An options object that configures conditional behavior of `update()` and
 * `delete()` calls in `DocumentReference`, `WriteBatch`, and `Transaction`.
 * Using Preconditions, these calls can be restricted to only apply to
 * documents that match the specified restrictions.
 */
export interface Precondition {
  /**
   * If set, the last update time to enforce.
   */
  readonly lastUpdateTime?: Timestamp

  /**
   * If set, enforces that the target document must or must not exist.
   */
  readonly exists?: boolean
}

/**
 * An options object that configures the behavior of `set()` calls in
 * `DocumentReference`, `WriteBatch` and `Transaction`. These calls can be
 * configured to perform granular merges instead of overwriting the target
 * documents in their entirety.
 */
export interface SetOptions {
  /**
   * Changes the behavior of a set() call to only replace the values specified
   * in its data argument. Fields omitted from the set() call remain
   * untouched.
   */
  readonly merge?: boolean

  /**
   * Changes the behavior of set() calls to only replace the specified field
   * paths. Any field path that is not specified is ignored and remains
   * untouched.
   *
   * It is an error to pass a SetOptions object to a set() call that is
   * missing a value for any of the fields specified here.
   */
  readonly mergeFields?: string[]
}

export interface FirestoreWriteBatch {
  set(doc: FirestoreDoc, data: any, options?: SetOptions)
  update(doc: FirestoreDoc, data: any, precondition?: Precondition)
  delete(doc: FirestoreDoc)
  commit(): Promise<any>
}

export interface FirestoreBatchOrTransaction extends Omit<FirestoreWriteBatch, 'commit'> {}

export interface FirestoreDoc {}

export interface FirestoreProvider {
  annaUusiBatch(): FirestoreWriteBatch
  annaDoc(uri: string): FirestoreDoc
  annaUusiAvain(): string
  annaDeleteArvo(): any // TODO: This is FieldValue, but is a different class depending where imported from.
}

export interface BatchManipulator {
  manipulate(firestoreProvider: FirestoreProvider, batch: FirestoreWriteBatch, juurilasku: Lasku, kasiteltava: LaskuBase)
}

export class LaskuTallennusService {
  constructor(
    private shared: LaskuSharedService,
    private laskuKopioija: LaskuKopioija,
    private laskuIndeksoija: LaskuIndeksoija,
    private currencyService: CurrencyService,
    private dateService: DateService,
    private laskuUriService: LaskuUriService,
    private translationService: TranslationService,
    private timestampService: TimestampProviderBase,
    private reskontraService: ReskontraService,
    private firestoreProvider: FirestoreProvider,
    private viitenumeroService: ViitenumeroService,
    private stringService: StringService,
  ) {}

  lisaaAsiakasBatchiin(asiakasId: string, asiakasAvain: string, asiakas: LaskunAsiakas, batch: FirestoreWriteBatch) {
    // Aseta avain
    asiakas.avain = asiakas.avain ? asiakas.avain : this.firestoreProvider.annaUusiAvain()

    // Luo reffit
    const uri = this.laskuUriService.getLaskuAsiakasUri(asiakasAvain, asiakas.avain)
    const ref = this.firestoreProvider.annaDoc(uri)

    const LEMON_TREE_ASIAKASID = '9' // Ohitetaan typehead kirjoitus Lemon Treelle -> dokumentti muuten liian suuri
    if (asiakasId !== LEMON_TREE_ASIAKASID) {
      const typeaheadUri = this.laskuUriService.getTypeaheadAsiakasDokumentinUriNew(asiakasAvain)
      const typeaheadRef = this.firestoreProvider.annaDoc(typeaheadUri)

      // Create typeahead data
      const typeaheadDataContainer = {}
      if (asiakas.poistettu) {
        typeaheadDataContainer[asiakas.avain] = this.firestoreProvider.annaDeleteArvo()
      } else {
        const typeaheadData: TypeaheadAsiakasIlmanAvainta = {
          nimi: asiakas.nimi,
          ytunnus: asiakas.ytunnus,
        }
        typeaheadDataContainer[asiakas.avain] = typeaheadData
      }

      // Update typeahead
      const options: SetOptions = { merge: true }
      batch.set(typeaheadRef, typeaheadDataContainer, options)
    }

    // Save asiakas
    asiakas.date = this.timestampService.now()
    const juurilasku = this.laskuKopioija.copyAsiakas(asiakas)
    juurilasku['haku'] = this.laskuIndeksoija.luoHakutiedotAsiakkaalle(asiakas)
    batch.set(ref, juurilasku)
  }

  public lisaaHistoriaMerkinta(kayttajanTiedot: Pick<KayttajanTiedot, 'asiakasAvain' | 'euid' | 'uid'>, juurilasku: Lasku, batchOrTransaction: FirestoreBatchOrTransaction) {
    const kopioitu = this.laskuKopioija.copyLasku(juurilasku)

    this.shared.poistaKaikkiLaskunHakuKentatMuistista(kopioitu)
    kopioitu.date = this.timestampService.now()
    kopioitu['tallentaja'] = kayttajanTiedot.uid
    if (kayttajanTiedot.euid) {
      kopioitu['tallentaja_euid'] = kayttajanTiedot.euid
    }

    const historiaAvain = this.firestoreProvider.annaUusiAvain()
    const historiaUri = this.laskuUriService.getCustomerLaskunHistoriaUri(kayttajanTiedot.asiakasAvain, juurilasku.avain, historiaAvain)
    const historiaRef = this.firestoreProvider.annaDoc(historiaUri)

    batchOrTransaction.set(historiaRef, kopioitu)
  }

  public lisaaToimintalokiMerkinta(
    kayttajanTiedot: KayttajanTiedot,
    tyyppi: LaskunToimintalokiTyyppi,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    batchOrTransaction: FirestoreBatchOrTransaction,
    parametrit?: LaskunToimintalokiSahkoinenParametrit | LaskunToimintalokiSpostiParametrit | LaskunToimintalokiTilastoParametrit,
  ) {
    const toimintalokiAvain = this.firestoreProvider.annaUusiAvain()
    const toimintalokiUri = this.laskuUriService.getCustomerLaskunToimintalokiUri(kayttajanTiedot.asiakasAvain, juurilasku.avain, toimintalokiAvain)
    const toimintalokiRef = this.firestoreProvider.annaDoc(toimintalokiUri)

    const lokidata: LaskuToimintaloki = {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      lasku_uid: kasiteltava.avain,
      pvm: this.timestampService.now(),
      // eslint-disable-next-line @typescript-eslint/naming-convention
      tekija_uid: kayttajanTiedot.uid,
      toiminto: tyyppi,
      // eslint-disable-next-line @typescript-eslint/naming-convention
      lasku_nro: this.shared.annaMuotoiltuLaskunumero(juurilasku, kasiteltava),
      parametrit: parametrit ?? null,
    }

    if (kayttajanTiedot.euid) {
      lokidata.emuloija_uid = kayttajanTiedot.euid
    }

    batchOrTransaction.set(toimintalokiRef, lokidata)
  }

  asetaLahettajanJaPaivittajanTiedot(kayttajanTiedot: KayttajanTiedot, juurilasku: Lasku, kasiteltava: LaskuBase, collector: LaskuChangeCollectorInterface) {
    const time = this.timestampService.now()

    if (!kasiteltava.luotu) {
      kasiteltava.luotu = time
      collector.addChange(juurilasku, kasiteltava, 'luotu', kasiteltava.luotu)
    }

    if (!kasiteltava.luoja) {
      kasiteltava.luoja = kayttajanTiedot.uid
      collector.addChange(juurilasku, kasiteltava, 'luoja', kasiteltava.luoja)
    }

    juurilasku.paivitetty = time
    juurilasku.paivittaja = kayttajanTiedot.uid
    collector.addJuurilaskuChange('paivitetty', kasiteltava.paivitetty)
    collector.addJuurilaskuChange('paivittaja', kasiteltava.paivittaja)

    if (juurilasku.avain !== kasiteltava.avain) {
      kasiteltava.paivitetty = time
      kasiteltava.paivittaja = kayttajanTiedot.uid
      collector.addChange(juurilasku, kasiteltava, 'paivitetty', kasiteltava.paivitetty)
      collector.addChange(juurilasku, kasiteltava, 'paivittaja', kasiteltava.paivittaja)
    }
  }

  lisaaTuoteBatchiin(asiakasId: string, asiakasAvain: string, tuote: AsiakkaanTuote, batch: FirestoreWriteBatch) {
    // Aseta avain
    tuote.$key = tuote.$key ? tuote.$key : this.firestoreProvider.annaUusiAvain()

    // Luo reffit
    const uri = this.laskuUriService.getLaskuTuoteUri(asiakasAvain, tuote.$key)
    const ref = this.firestoreProvider.annaDoc(uri)
    const typeaheadUri = this.laskuUriService.getTypeaheadTuoteDokumentinUriNew(asiakasAvain)
    const typeaheadRef = this.firestoreProvider.annaDoc(typeaheadUri)

    // Create typeahead data
    const typeaheadDataContainer = {}
    if (tuote.poistettu) {
      typeaheadDataContainer[tuote.$key] = this.firestoreProvider.annaDeleteArvo()
    } else {
      const typeaheadData: TypeaheadTuoteIlmanAvainta = {
        nimi: tuote.nimi,
      }
      if (tuote.valuutta) {
        typeaheadData.valuutta = tuote.valuutta
      }
      if (tuote.hinta !== null && tuote.hinta !== undefined) {
        typeaheadData.hinta = tuote.hinta
      }
      if (tuote.yksikko) {
        typeaheadData.yksikko = tuote.yksikko
      }
      typeaheadDataContainer[tuote.$key] = typeaheadData
    }

    // Update typeahead
    const options: SetOptions = { merge: true }
    batch.set(typeaheadRef, typeaheadDataContainer, options)

    // Tallenna tuote
    tuote.date = this.timestampService.now()
    const juurilasku = this.laskuKopioija.copyTuote(tuote)
    juurilasku['haku'] = this.laskuIndeksoija.luoHakutiedotTuotteelle(tuote)
    batch.set(ref, juurilasku)
  }

  lisaaToimittajaBatchiin(asiakasId: string, asiakasAvain: string, uid: string, toimittaja: LaskuToimittaja, batch: FirestoreWriteBatch) {
    // Aseta avain
    if (!toimittaja.avain) {
      toimittaja.avain = this.firestoreProvider.annaUusiAvain()
      toimittaja.luoja = uid
      toimittaja.luotu = this.timestampService.now()
    }

    // Luo reffit
    const uri = this.laskuUriService.getLaskuToimittajaUri(asiakasAvain, toimittaja.avain)
    const ref = this.firestoreProvider.annaDoc(uri)
    const uusiUri = this.laskuUriService.getLaskuToimittajaUri(asiakasAvain, toimittaja.avain)
    const uusiRef = this.firestoreProvider.annaDoc(uusiUri)
    const typeaheadUri = this.laskuUriService.getTypeaheadToimittajaDokumentinUriNew(asiakasAvain)
    const typeaheadRef = this.firestoreProvider.annaDoc(typeaheadUri)

    // Create typeahead data
    const typeaheadDataContainer = {}
    const typeaheadData: TypeaheadToimittajaIlmanAvainta = {
      numero: toimittaja.numero,
      nimi: toimittaja.nimi,
      ytunnus: toimittaja.ytunnus || null,
      poistettu: toimittaja.poistettu,
    }
    typeaheadDataContainer[toimittaja.avain] = typeaheadData

    // Update typeahead
    batch.set(typeaheadRef, typeaheadDataContainer, { merge: true })

    // Tallenna toimittaja
    toimittaja.paivitetty = this.timestampService.now()
    toimittaja.paivittaja = uid
    const copied = this.laskuKopioija.copyToimittaja(toimittaja)
    batch.set(ref, copied)

    // Replikoi toimittaja
    const toimittajaReplikointiUri = this.laskuUriService.getToimittajaReplikointiTyojonoUri(asiakasId, this.firestoreProvider.annaUusiAvain())
    const toimittajaReplikointiRef = this.firestoreProvider.annaDoc(toimittajaReplikointiUri)
    const tyojono: ReplikoiToimittajaTyojonoData = {
      asiakasId: asiakasId,
      toimittajaAvain: toimittaja.avain,
      created: this.timestampService.now(),
    }
    batch.set(toimittajaReplikointiRef, tyojono)
  }

  async lahetaSahkoinenUudelleen(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, kasiteltavaOriginal: LaskuBase, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuSahkoinenlUri(kayttajanTiedot.asiakasId, this.firestoreProvider.annaUusiAvain())
    const batch = this.firestoreProvider.annaUusiBatch()

    kasiteltava.sahkoinen.status = LaskuSahkoinenLahetysStatusKoodi.PROSESSOIDAAN

    // Lisää lokimerkinnät
    const parametrit: LaskunToimintalokiSahkoinenParametrit = {
      osoite: kasiteltava.sahkoinen.osoite,
    }
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SAHKOINEN, juurilasku, kasiteltava, batch, parametrit)

    // Päivitä virheellinen email Lemonaid asiakkaassa
    const laskunAsiakas = kasiteltava.asiakas
    laskunAsiakas.sahkoinenosoite = kasiteltava.sahkoinen.osoite
    laskunAsiakas.viimeisinLaskuLahetetty = LaskunLahetystapa.SAHKOINEN

    // Note: both of these could be more granular and not write the whole objects.
    // The structure should be different though, it's hard to say what all _could_
    // have changed
    collector.addChange(juurilasku, kasiteltava, 'asiakas', laskunAsiakas)
    collector.addChange(juurilasku, kasiteltava, 'sahkoinen', kasiteltava.sahkoinen)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuSahkoinentyojononMerkinta = {
      laskuAvain: juurilasku.avain,
      kasiteltavaAvain: kasiteltava.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojonomerkintaUri, tyojonomerkinta)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    this.lisaaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, laskunAsiakas, batch)

    await batch.commit()

    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async lahetaEmailUudelleen(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    vastaanottaja: EmailLahetysStatus,
    vanhaEmail: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuEmailUri(kayttajanTiedot.asiakasId, this.firestoreProvider.annaUusiAvain())
    const batch = this.firestoreProvider.annaUusiBatch()

    vastaanottaja.status = EmailLahetysStatusKoodi.PROSESSOIDAAN
    for (const v of kasiteltava.email?.vastaanottajat || []) {
      if (v.email === vastaanottaja.email) {
        v.status = EmailLahetysStatusKoodi.PROSESSOIDAAN
      }
    }

    // Päivitä virheellinen email Lemonaid asiakkaassa
    const laskunAsiakas = kasiteltava.asiakas
    if (laskunAsiakas.laskunVastaanottajat) {
      const index = laskunAsiakas.laskunVastaanottajat.indexOf(vanhaEmail)
      if (index > -1) {
        laskunAsiakas.laskunVastaanottajat.splice(index, 1)
      }
    } else {
      laskunAsiakas.laskunVastaanottajat = []
    }
    laskunAsiakas.laskunVastaanottajat.push(vastaanottaja.email)
    laskunAsiakas.viimeisinLaskuLahetetty = LaskunLahetystapa.SAHKOPOSTI

    // Note: both of these could be more granular and not write the whole objects.
    // The structure should be different though, it's hard to say what all _could_
    // have changed
    collector.addChange(juurilasku, kasiteltava, 'asiakas', laskunAsiakas)
    collector.addChange(juurilasku, kasiteltava, 'email', kasiteltava.email)

    // Lisää lokimerkinnät
    const parametrit: LaskunToimintalokiSpostiParametrit = {
      emailit: [vastaanottaja.email],
    }
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SPOSTI, juurilasku, kasiteltava, batch, parametrit)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuEmailtyojononMerkinta = {
      kasiteltavaAvain: kasiteltava.avain,
      laskuAvain: juurilasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojonomerkintaUri, tyojonomerkinta)

    this.lisaaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, laskunAsiakas, batch)

    await batch.commit()

    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async peruutaLuottotappiomerkinta(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, kasiteltavaOriginal: LaskuBase, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää lokimerkinnät
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LUOTTOTAPPIO_MERKINTA_PERUUTETTU, juurilasku, kasiteltava, batch, null)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    // Vie Lemonatoriin
    this.lisaaLemonatoriinVientiTyojonoBatchiin(juurilasku, kasiteltava, kayttajanTiedot, batch)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async silentLaskeReskontraUudelleen(kayttajanTiedot: Pick<KayttajanTiedot, 'asiakasAvain' | 'asiakasId'>, juurilasku: Lasku, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const kasiteltava = this.shared.annaViimeisinEiLuonnosLasku(juurilasku)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    const collector = new LaskuChangeCollector('existing-document')

    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    await batch.commit()

    return { juurilasku, kasiteltava }
  }

  async laskeReskontraUudelleen(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const kasiteltavaOriginal = this.shared.annaViimeisinEiLuonnosLasku(juurilaskuOriginal)
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    await batch.commit()

    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  /** HUOM! TÄMÄ YLIKIRJOITTAA AINA KOKO LASKUN!! */
  async tallennaUlkoinenLasku(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    lokimerkinnat: LaskutoimintalokiMerkinta[],
    batchManipulator?: BatchManipulator,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää lokimerkinnät
    for (const lokimerkinta of lokimerkinnat) {
      this.lisaaToimintalokiMerkinta(kayttajanTiedot, lokimerkinta.toiminto, juurilasku, kasiteltava, batch, lokimerkinta.parametrit)
    }

    this._tiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessa(kayttajanTiedot, juurilasku, kasiteltava, batch, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    batch.set(laskuRef, juurilasku)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    // Vie Lemonatoriin
    this.lisaaLemonatoriinVientiTyojonoBatchiin(juurilasku, kasiteltava, kayttajanTiedot, batch)

    // Lisää lähetystiedot
    const lahetystietojenLuoja = new LaskuLahetystietojenLuoja(this.dateService, this.currencyService, this.shared, this.timestampService)
    const tallennettavat = lahetystietojenLuoja.luoLahetystiedot(juurilasku, kayttajanTiedot.asiakasId)

    for (const tallennettava of tallennettavat) {
      const laskunTietojenUri = this.laskuUriService.getLaskuLahetystietoUri(kayttajanTiedot.asiakasAvain, tallennettava.kasiteltavaAvain)
      const laskunTietojenDoc = this.firestoreProvider.annaDoc(laskunTietojenUri)
      batch.set(laskunTietojenDoc, tallennettava, { merge: true })
    }

    if (batchManipulator) {
      batchManipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  paivitaTilaJaIndeksoiUudelleen(kayttajanTiedot: KayttajanTiedot, juurilasku: Lasku, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const collector = new LaskuChangeCollector('existing-document')
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)
    return this._indeksoiUudelleenImpl(kayttajanTiedot, juurilasku, reskontra, collector)
  }

  indeksoiUudelleen(kayttajanTiedot: KayttajanTiedot, juurilasku: Lasku, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    return this._indeksoiUudelleenImpl(kayttajanTiedot, juurilasku, reskontra, new LaskuChangeCollector('existing-document'))
  }

  private async _indeksoiUudelleenImpl(kayttajanTiedot: KayttajanTiedot, juurilasku: Lasku, reskontra: LaskuReskontra[], collector: LaskuChangeCollectorInterface): Promise<JuurilaskuJaKasiteltava> {
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    const kasiteltava = this.shared.annaViimeisinEiLuonnosLasku(juurilasku)

    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.annaTallennettavaKopio(juurilasku, kasiteltava, kayttajanTiedot, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    await batch.commit()
    return { juurilasku, kasiteltava }
  }

  async merkitseLuottotappioksi(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, kasiteltavaOriginal: LaskuBase, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    juurilasku.tila = LaskunTila.luottotappio
    collector.addJuurilaskuChange('tila', juurilasku.tila)

    // Lisää lokimerkinnät
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.MERKITTY_LUOTTOTAPPIOKSI, juurilasku, kasiteltava, batch, null)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    // Vie Lemonatoriin
    this.lisaaLemonatoriinVientiTyojonoBatchiin(juurilasku, kasiteltava, kayttajanTiedot, batch)

    await batch.commit()

    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async tallennaKommentti(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    kommentti: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    if (this.stringService.removeAllWhiteSpaces(kommentti)) {
      juurilasku.kommentti = kommentti.trim()
      collector.addJuurilaskuChange('kommentti', juurilasku.kommentti)
    } else {
      delete juurilasku.kommentti
      collector.addJuurilaskuChange('kommentti', this.firestoreProvider.annaDeleteArvo())
    }

    // Lisää lokimerkinnät
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.KOMMENTTI_PAIVITETTY, juurilasku, kasiteltava, batch, null)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    await batch.commit()

    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async lisaaReskontraMerkinta(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    suoritus: number,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const suoritettuBig = new Big(suoritus).round(2, Big.roundHalfUp)
    const now = this.timestampService.now()
    const localDate = this.dateService.timestampToLocalDate(now)
    const numberDate = this.dateService.localDateToNumber(localDate)
    const reskontramerkinta: LaskuReskontra = {
      avain: this.firestoreProvider.annaUusiAvain(),
      tekijaUid: kayttajanTiedot.uid,
      suoritus: this.currencyService.muutaBigDecimalRahaksi(suoritettuBig),
      pvm: now,
      pvml: localDate,
      p: numberDate,
      luotu: now,
      tyyppi: 'kasin',
    }

    reskontra.push(reskontramerkinta)
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna reskontramerkintä
    const reskontramerkintaUri = this.laskuUriService.getCustomerLaskunReskontraUri(kayttajanTiedot.asiakasAvain, juurilasku.avain, reskontramerkinta.avain)
    const reskontramerkintaDoc = this.firestoreProvider.annaDoc(reskontramerkintaUri)
    batch.set(reskontramerkintaDoc, reskontramerkinta)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)
    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  private _lisaaKateislaskunSuoritusReskontraan(kayttajanTiedot: KayttajanTiedot, juurilasku: Lasku, kasiteltava: LaskuBase, reskontra: LaskuReskontra[], batch: FirestoreWriteBatch) {
    const onKateislasku = this.shared.onkoKateislasku(juurilasku, kasiteltava)
    if (!onKateislasku) {
      return
    }
    const summa = this.shared.annaLaskunSummat(kasiteltava).yhteensaKaikki.round(2, Big.roundHalfUp)
    const now = this.timestampService.now()
    const localDate = this.dateService.timestampToLocalDate(now)
    const reskontramerkinta: LaskuReskontra = {
      avain: this.firestoreProvider.annaUusiAvain(),
      tekijaUid: kayttajanTiedot.uid,
      suoritus: this.currencyService.muutaBigDecimalRahaksi(summa),
      pvm: now,
      pvml: localDate,
      p: this.dateService.localDateToNumber(localDate),
      luotu: now,
      tyyppi: 'kasin',
    }
    reskontra.push(reskontramerkinta)
    const reskontramerkintaUri = this.laskuUriService.getCustomerLaskunReskontraUri(kayttajanTiedot.asiakasAvain, juurilasku.avain, reskontramerkinta.avain)
    batch.set(this.firestoreProvider.annaDoc(reskontramerkintaUri), reskontramerkinta)
  }

  annaEdellinenEiNollaReskontramerkinta(reskontra: LaskuReskontra[]): null | LaskuReskontra {
    if (reskontra && reskontra.length > 0) {
      for (let i = reskontra.length; i > 0; i--) {
        const merkinta = reskontra[i - 1]
        const suoritus = new Big(merkinta.suoritus)
        if (!suoritus.round(2, Big.roundHalfUp).eq(new Big('0'))) {
          return merkinta
        }
      }
    }
    return null
  }

  merkitseLaskuTaysinMaksetuksi(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const viimeinenTavallinenOriginal = this.shared.annaViimeisinTavallinenLasku(juurilaskuOriginal)
    const summatJaTila = this.shared.annaLaskunSummatJaTilaLaskulleReskontralla(juurilaskuOriginal, reskontra)

    // const roundedYhteensa = summatJaTila.laskunSummat.yhteensaKaikki.round(2, Big.roundHalfUp)
    // const roundedReskontra = summatJaTila.reskontrasumma.round(2, Big.roundHalfUp)

    const avoinna = summatJaTila.avoinna.round(2, Big.roundHalfUp)

    let suoritus = new Big('0')
    if (avoinna.eq(new Big('0'))) {
      const edellinenEiNolla = this.annaEdellinenEiNollaReskontramerkinta(reskontra)
      if (edellinenEiNolla) {
        suoritus = suoritus.minus(edellinenEiNolla.suoritus)
      }
    } else {
      suoritus = avoinna
    }

    const maara = this.currencyService.muutaBigDecimalRahaksi(suoritus)

    return this.lisaaReskontraMerkinta(kayttajanTiedot, juurilaskuOriginal, viimeinenTavallinenOriginal, reskontra, maara)
  }

  async poistaLuonnos(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, kasiteltavaOriginal: LaskuBase, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const kopiot = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)
    const juurilasku = kopiot.juurilasku
    let kasiteltava = kopiot.kasiteltava
    const collector = kopiot.collector

    // Sanitization:
    kasiteltava.email = null
    kasiteltava.print = null
    kasiteltava.sahkoinen = null
    kasiteltava.nro = EI_LASKUNUMEROA_NUMERO

    collector.addChange(juurilasku, kasiteltava, 'email', kasiteltava.email)
    collector.addChange(juurilasku, kasiteltava, 'print', kasiteltava.print)
    collector.addChange(juurilasku, kasiteltava, 'sahkoinen', kasiteltava.sahkoinen)
    collector.addChange(juurilasku, kasiteltava, 'nro', kasiteltava.nro)

    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)

    const batch = this.firestoreProvider.annaUusiBatch()

    if (juurilasku.avain === kasiteltava.avain) {
      // Tämä on ensimmäinen lasku, poista koko hakuindeksi, jolloin lasku ei näy hauissa, eli on käyttäjälle poistettu
      juurilasku['haku'] = null
      collector.addHakuChange(this.firestoreProvider.annaDeleteArvo())
      juurilasku.listauksessa = false
      collector.addJuurilaskuChange('listauksessa', juurilasku.listauksessa)
      this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
      collector.transferChangesToBatch(laskuRef, batch)
    } else {
      const viimeinenLiittyvaLasku = this.shared.annaViimeinenLiittyvaLasku(juurilasku)
      if (viimeinenLiittyvaLasku?.avain === kasiteltava.avain) {
        if (juurilasku?.liittyvatLaskut?.[viimeinenLiittyvaLasku.avain]) {
          delete juurilasku.liittyvatLaskut[viimeinenLiittyvaLasku.avain]
          collector.deleteKasiteltava(viimeinenLiittyvaLasku, this.firestoreProvider.annaDeleteArvo())
        }
      }

      if (viimeinenLiittyvaLasku) {
        kasiteltava = viimeinenLiittyvaLasku
      } else {
        kasiteltava = juurilasku
      }

      // Päivitä summat
      this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

      // Aseta tila
      this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

      // Prepare for save
      this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

      this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
      collector.transferChangesToBatch(laskuRef, batch)
    }

    // Lisää lokimerkinnät
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LUONNOS_POISTETTU, juurilasku, kasiteltava, batch)
    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async tallennaLuonnos(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    toistuvaLaskuAihio?: boolean,
    ensimmainenLahetyspvm?: number,
    toistoasetukset?: LaskuLahetyksenToistoasetukset,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    if (toistuvaLaskuAihio) {
      juurilasku.toistuvaLaskuaihio = true
      collector.addJuurilaskuChange('toistuvaLaskuaihio', true)

      if (ensimmainenLahetyspvm) {
        const uudetPvmt = this.laskuKopioija.laskePaivamaaratJaErapaivaPaivamaaralla(ensimmainenLahetyspvm, juurilaskuOriginal)
        Object.assign(juurilasku, uudetPvmt)
        Object.assign(kasiteltava, uudetPvmt)
        collector.addChange(juurilasku, kasiteltava, 'pvm', uudetPvmt.pvm)
        collector.addChange(juurilasku, kasiteltava, 'pvml', uudetPvmt.pvml)
        collector.addChange(juurilasku, kasiteltava, 'p', uudetPvmt.p)
        collector.addChange(juurilasku, kasiteltava, 'erapvm', uudetPvmt.erapvm)
        collector.addChange(juurilasku, kasiteltava, 'erapvml', uudetPvmt.erapvml)
        collector.addChange(juurilasku, kasiteltava, 'erap', uudetPvmt.erap)
        collector.addChange(juurilasku, kasiteltava, 'toimituspvm', uudetPvmt.toimituspvm)
        collector.addChange(juurilasku, kasiteltava, 'toimituspvml', uudetPvmt.toimituspvml)
        collector.addChange(juurilasku, kasiteltava, 'toimitusp', uudetPvmt.toimitusp)
        collector.addChange(juurilasku, kasiteltava, 'date', uudetPvmt.date)
      }
    } else {
      // Sanitization:
      kasiteltava.email = null
      kasiteltava.print = null
      kasiteltava.sahkoinen = null
      collector.addChange(juurilasku, kasiteltava, 'email', null)
      collector.addChange(juurilasku, kasiteltava, 'print', null)
      collector.addChange(juurilasku, kasiteltava, 'sahkoinen', null)
    }

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return !tuote || !tuote.tuote || (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    // console.log('TÄÄSSÄÄ' + kasiteltava.avain)

    // const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    // const tyojonoUri = this.laskuUriService.getTyojonoLaskuTulostusUri(kayttajanTiedot.asiakasId, tyojonoId)
    const batch = this.firestoreProvider.annaUusiBatch()

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Aseta tila
    juurilasku.tila = LaskunTila.luonnos
    collector.addJuurilaskuChange('tila', juurilasku.tila)

    // Lisää batchiin tuotteet ja asiakas
    // this.paivitaTuotteetJaAsiakas(kasiteltava, kayttajanTiedot, batch)

    // Lisää lokimerkinnät
    const luontiTyyppi = kasiteltava.avain === UUDEN_LASKUN_AVAIN ? LaskunToimintalokiTyyppi.LUONNOS_LUOTU : LaskunToimintalokiTyyppi.LUONNOS_TALLENNETTU
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, luontiTyyppi, juurilasku, kasiteltava, batch)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    if (toistuvaLaskuAihio) {
      this.lisaaTuotteetJaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
      delete juurilasku['haku']
      collector.addHakuChange(this.firestoreProvider.annaDeleteArvo())
    }

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    juurilasku.nro = EI_LASKUNUMEROA_NUMERO
    collector.addChange(juurilasku, kasiteltava, 'nro', juurilasku.nro)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)

    collector.transferChangesToBatch(laskuRef, batch)

    this.lisaaHakuindeksiTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    if (toistuvaLaskuAihio && toistoasetukset) {
      this._lisaaToistuvaLaskuBatchiin(kayttajanTiedot, juurilasku, toistoasetukset, batch)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async poistaToistuvaLasku(kayttajanTiedot: KayttajanTiedot, toistuvaLasku: ToistuvaLasku): Promise<void> {
    const batch = this.firestoreProvider.annaUusiBatch()
    const paivitys: Partial<ToistuvaLasku> = {
      poistettu: true,
      seuraavaLahetysPvm: null,
      paivitetty: this.timestampService.now(),
      paivittaja: kayttajanTiedot.uid,
    }
    const toistuvanUri = this.laskuUriService.getToistuvanLaskunUri(kayttajanTiedot.asiakasAvain, toistuvaLasku.lasku.avain)
    batch.update(this.firestoreProvider.annaDoc(toistuvanUri), paivitys)
    this._lisaaToistuvanLaskunHistoriaMerkinta(kayttajanTiedot, { ...toistuvaLasku, ...paivitys }, batch)
    await batch.commit()
  }

  private _lisaaToistuvaLaskuBatchiin(kayttajanTiedot: KayttajanTiedot, juurilasku: Lasku, toistoasetukset: LaskuLahetyksenToistoasetukset, batch: FirestoreWriteBatch) {
    const toistuvaLasku: ToistuvaLasku = {
      lasku: juurilasku,
      toisto: toistoasetukset,
      seuraavaLahetysPvm: toistoasetukset.ensimmainenLahetyspvm,
      lahetyksia: 0,
      poistettu: false,
      paivitetty: this.timestampService.now(),
      paivittaja: kayttajanTiedot.uid,
    }
    const toistuvanUri = this.laskuUriService.getToistuvanLaskunUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    batch.set(this.firestoreProvider.annaDoc(toistuvanUri), toistuvaLasku)
    this._lisaaToistuvanLaskunHistoriaMerkinta(kayttajanTiedot, toistuvaLasku, batch)
  }

  private _lisaaToistuvanLaskunHistoriaMerkinta(kayttajanTiedot: KayttajanTiedot, toistuvaLasku: ToistuvaLasku, batch: FirestoreWriteBatch) {
    const historiaUri = this.laskuUriService.getToistuvanLaskunHistoriaAvaimellaUri(kayttajanTiedot.asiakasAvain, toistuvaLasku.lasku.avain, this.firestoreProvider.annaUusiAvain())
    batch.set(this.firestoreProvider.annaDoc(historiaUri), toistuvaLasku)
  }

  merkitseLaskuLahetetyksiTulostamalla(params: LaskuTulostusParametrit): Promise<JuurilaskuJaKasiteltava> {
    const { kayttajanTiedot, juurilasku, kasiteltava, reskontra, batchManipulator, tasapainoitaEnsinKayttaenViitenumeroa, ostavanAsiakkaanAvain } = params
    const luontiTyyppi = juurilasku.avain === kasiteltava.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    const merkinnat: LaskutoimintalokiMerkinta[] = [{ toiminto: luontiTyyppi }, { toiminto: LaskunToimintalokiTyyppi.LAHETETTY_TULOSTA }]

    return this._merkitseLaskuLahetetyksiTulostamallaLokiMerkinnnoilla(
      kayttajanTiedot,
      juurilasku,
      kasiteltava,
      reskontra,
      merkinnat,
      batchManipulator,
      tasapainoitaEnsinKayttaenViitenumeroa,
      ostavanAsiakkaanAvain,
    )
  }

  merkitseLaskuLahetetyksiTulostamallaToisenHyvaksyntajonoon(
    kayttajanTiedot: KayttajanTiedot,
    osoite: LaskunSahkoinenOsoite,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    reskontra: LaskuReskontra[],
    batchManipulator?: BatchManipulator,
    tasapainoitaEnsinKayttaenViitenumeroa?: string,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const luontiTyyppi = juurilasku.avain === kasiteltava.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    const parametrit: LaskunToimintalokiSahkoinenParametrit = {
      osoite: osoite,
    }
    const merkinnat: LaskutoimintalokiMerkinta[] = [
      { toiminto: luontiTyyppi },
      { toiminto: LaskunToimintalokiTyyppi.LAHETETTY_TULOSTA_TOISEN_HYVAKSYNTAJONOON_ODOTTAMAAN_HYVAKSYNTAA, parametrit: parametrit },
    ]
    return this._merkitseLaskuLahetetyksiTulostamallaLokiMerkinnnoilla(
      kayttajanTiedot,
      juurilasku,
      kasiteltava,
      reskontra,
      merkinnat,
      batchManipulator,
      tasapainoitaEnsinKayttaenViitenumeroa,
      ostavanAsiakkaanAvain,
    )
  }

  private async _merkitseLaskuLahetetyksiTulostamallaLokiMerkinnnoilla(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    lokimerkinnat: LaskutoimintalokiMerkinta[],
    batchManipulator?: BatchManipulator,
    tasapainoitaEnsinKayttaenViitenumeroa?: string,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    // Sanitization:
    kasiteltava.email = null
    kasiteltava.sahkoinen = null

    this.paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava, LaskunLahetystapa.ITSE)

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuTulostusUri(kayttajanTiedot.asiakasId, tyojonoId)
    const batch = this.firestoreProvider.annaUusiBatch()

    this._lisaaKateislaskunSuoritusReskontraan(kayttajanTiedot, juurilasku, kasiteltava, reskontra, batch)

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Asetetaan käsiteltävä lukkoon, jotta sitä ei voi enää muokata
    kasiteltava.lukossa = true
    kasiteltava.print = {
      done: null,
      start: this.timestampService.now(),
    }

    // console.log(kasiteltava.print.start, typeof kasiteltava.print.start, kasiteltava.print.start.constructor.name)

    // Aseta tila
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää batchiin tuotteet ja asiakas
    this.lisaaTuotteetJaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
    this._poistaRekisterivalinnatRiveilta(kasiteltava)

    // Lisää lokimerkinnät
    for (const lokimerkinta of lokimerkinnat) {
      this.lisaaToimintalokiMerkinta(kayttajanTiedot, lokimerkinta.toiminto, juurilasku, kasiteltava, batch, lokimerkinta.parametrit)
    }

    this._tiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessa(kayttajanTiedot, juurilasku, kasiteltava, batch, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    if (tasapainoitaEnsinKayttaenViitenumeroa) {
      const tyojonomerkinta: LaskuTasapainoitaJaLahetaTyojonomerkinta = {
        kanava: LaskunLahetystapa.ITSE,
        viitenumero: tasapainoitaEnsinKayttaenViitenumeroa,
        kasiteltavaAvain: kasiteltava.avain,
        laskuAvain: juurilasku.avain,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
        asiakasId: kayttajanTiedot.asiakasId,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
      }
      if (ostavanAsiakkaanAvain) {
        tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
      }
      const tasapainoitusUri = this.laskuUriService.getTyojonoLaskuTasapainoitaJaLahetaUri(kayttajanTiedot.asiakasId, tyojonoId)
      const tyojoRef = this.firestoreProvider.annaDoc(tasapainoitusUri)
      batch.set(tyojoRef, tyojonomerkinta)
    } else {
      const tyojonomerkinta: LaskuTulostamistyojononMerkinta = {
        laskuAvain: juurilasku.avain,
        kasiteltavaAvain: kasiteltava.avain,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
        asiakasId: kayttajanTiedot.asiakasId,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
      }
      if (ostavanAsiakkaanAvain) {
        tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
      }
      const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojonomerkintaUri, tyojonomerkinta)
    }

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    // if (juurilasku.print && juurilasku.print.start) {
    //   console.log(juurilasku.print.start, typeof juurilasku.print.start, juurilasku.print.start.constructor.name)
    // }

    if (batchManipulator) {
      batchManipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  merkitseLaskuLahetetyksiSahkoisesti(
    kayttajanTiedot: KayttajanTiedot,
    osoite: LaskunSahkoinenOsoite,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    batchManipulator?: BatchManipulator,
    tasapainoitaEnsinKayttaenViitenumeroa?: string,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const luontiTyyppi = juurilaskuOriginal.avain === kasiteltavaOriginal.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    const parametrit: LaskunToimintalokiSahkoinenParametrit = {
      osoite: osoite,
    }
    const merkinnat: LaskutoimintalokiMerkinta[] = [{ toiminto: luontiTyyppi }, { toiminto: LaskunToimintalokiTyyppi.LAHETETTY_SAHKOINEN, parametrit: parametrit }]
    return this._merkitseLaskuLahetetyksiSahkoisestiLokimerkinnoilla(
      kayttajanTiedot,
      osoite,
      juurilaskuOriginal,
      kasiteltavaOriginal,
      reskontra,
      merkinnat,
      batchManipulator,
      tasapainoitaEnsinKayttaenViitenumeroa,
      ostavanAsiakkaanAvain,
    )
  }

  merkitseLaskuLahetetyksiSahkoisestiToisenHyvaksyntajonosta(
    kayttajanTiedot: KayttajanTiedot,
    osoite: LaskunSahkoinenOsoite,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    reskontra: LaskuReskontra[],
    batchManipulator?: BatchManipulator,
    tasapainoitaEnsinKayttaenViitenumeroa?: string,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const parametrit: LaskunToimintalokiSahkoinenParametrit = {
      osoite: osoite,
    }
    const merkinnat: LaskutoimintalokiMerkinta[] = [{ toiminto: LaskunToimintalokiTyyppi.LAHETETTY_SAHKOISESTI_TOISEN_HYVAKSYNTAJONOSTA_HYVAKSYNNAN_JALKEEN, parametrit: parametrit }]
    return this._merkitseLaskuLahetetyksiSahkoisestiLokimerkinnoilla(
      kayttajanTiedot,
      osoite,
      juurilasku,
      kasiteltava,
      reskontra,
      merkinnat,
      batchManipulator,
      tasapainoitaEnsinKayttaenViitenumeroa,
      ostavanAsiakkaanAvain,
    )
  }

  private async _merkitseLaskuLahetetyksiSahkoisestiLokimerkinnoilla(
    kayttajanTiedot: KayttajanTiedot,
    osoite: LaskunSahkoinenOsoite,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    lokimerkinnat: LaskutoimintalokiMerkinta[],
    batchManipulator?: BatchManipulator,
    tasapainoitaEnsinKayttaenViitenumeroa?: string,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    // Sanitization:
    kasiteltava.email = null
    kasiteltava.print = null

    this.paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava, LaskunLahetystapa.SAHKOINEN)

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuSahkoinenlUri(kayttajanTiedot.asiakasId, tyojonoId)
    const batch = this.firestoreProvider.annaUusiBatch()

    this._lisaaKateislaskunSuoritusReskontraan(kayttajanTiedot, juurilasku, kasiteltava, reskontra, batch)

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Asetetaan käsiteltävä lukkoon, jotta sitä ei voi enää muokata
    kasiteltava.lukossa = true
    kasiteltava.sahkoinen = {
      done: null,
      start: this.timestampService.now(),
      osoite: osoite,
      status: LaskuSahkoinenLahetysStatusKoodi.PROSESSOIDAAN,
    }

    // console.log(kasiteltava.print.start, typeof kasiteltava.print.start, kasiteltava.print.start.constructor.name)

    // Aseta tila
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    kasiteltava.asiakas.sahkoinenosoite = osoite

    // Lisää batchiin tuotteet ja asiakas
    this.lisaaTuotteetJaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
    this._poistaRekisterivalinnatRiveilta(kasiteltava)

    // Lisää lokimerkinnät
    for (const lokimerkinta of lokimerkinnat) {
      this.lisaaToimintalokiMerkinta(kayttajanTiedot, lokimerkinta.toiminto, juurilasku, kasiteltava, batch, lokimerkinta.parametrit)
    }

    this._tiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessa(kayttajanTiedot, juurilasku, kasiteltava, batch, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    if (tasapainoitaEnsinKayttaenViitenumeroa) {
      const tyojonomerkinta: LaskuTasapainoitaJaLahetaTyojonomerkinta = {
        kanava: LaskunLahetystapa.SAHKOINEN,
        viitenumero: tasapainoitaEnsinKayttaenViitenumeroa,
        kasiteltavaAvain: kasiteltava.avain,
        laskuAvain: juurilasku.avain,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
        asiakasId: kayttajanTiedot.asiakasId,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
      }
      if (ostavanAsiakkaanAvain) {
        tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
      }
      const tasapainoitusUri = this.laskuUriService.getTyojonoLaskuTasapainoitaJaLahetaUri(kayttajanTiedot.asiakasId, tyojonoId)
      const tyojoRef = this.firestoreProvider.annaDoc(tasapainoitusUri)
      batch.set(tyojoRef, tyojonomerkinta)
    } else {
      // Tallenna tyojono
      const tyojonomerkinta: LaskuSahkoinentyojononMerkinta = {
        laskuAvain: juurilasku.avain,
        kasiteltavaAvain: kasiteltava.avain,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
        asiakasId: kayttajanTiedot.asiakasId,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
      }
      if (ostavanAsiakkaanAvain) {
        tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
      }
      const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojonomerkintaUri, tyojonomerkinta)
    }

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    if (batchManipulator) {
      batchManipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    // if (juurilasku.print && juurilasku.print.start) {
    //   console.log(juurilasku.print.start, typeof juurilasku.print.start, juurilasku.print.start.constructor.name)
    // }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async lahetaLaskuUudelleen(kayttajanTiedot: KayttajanTiedot, juurilaskuOriginal: Lasku, kasiteltavaOriginal: LaskuBase, reskontra: LaskuReskontra[]): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    if (kasiteltava.sahkoinen) {
      // Asetetaan sähköiset lähetystiedot
      kasiteltava.sahkoinen.done = null
      kasiteltava.sahkoinen.status = LaskuSahkoinenLahetysStatusKoodi.PROSESSOIDAAN
      kasiteltava.sahkoinen.start = this.timestampService.now()

      collector.addChangePath(juurilasku, kasiteltava, 'sahkoinen.done', kasiteltava.sahkoinen.done)
      collector.addChangePath(juurilasku, kasiteltava, 'sahkoinen.status', kasiteltava.sahkoinen.status)
      collector.addChangePath(juurilasku, kasiteltava, 'sahkoinen.start', kasiteltava.sahkoinen.start)

      // Lisää lokimerkinnät
      const parametrit: LaskunToimintalokiSahkoinenParametrit = {
        osoite: kasiteltava.sahkoinen.osoite,
      }
      this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SAHKOINEN, juurilasku, kasiteltava, batch, parametrit)

      // Lisää työjonomerkinnät
      const tyojonomerkinta: LaskuSahkoinentyojononMerkinta = {
        laskuAvain: juurilasku.avain,
        kasiteltavaAvain: kasiteltava.avain,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
        asiakasId: kayttajanTiedot.asiakasId,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
      }
      const tyojonoUri = this.laskuUriService.getTyojonoLaskuSahkoinenlUri(kayttajanTiedot.asiakasId, tyojonoId)
      const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojonomerkintaUri, tyojonomerkinta)
    } else if (kasiteltava.email) {
      // Asetetaan email tiedot:
      kasiteltava.email.start = this.timestampService.now()
      kasiteltava.email.done = null
      for (const vastaanottaja of kasiteltava.email.vastaanottajat) {
        vastaanottaja.status = EmailLahetysStatusKoodi.PROSESSOIDAAN
      }
      collector.addChangePath(juurilasku, kasiteltava, 'email.start', kasiteltava.email.start)
      collector.addChangePath(juurilasku, kasiteltava, 'email.done', kasiteltava.email.done)
      collector.addChangePath(juurilasku, kasiteltava, 'email.vastaanottajat', kasiteltava.email.vastaanottajat)

      // Lisää lokimerkinnät
      const parametrit: LaskunToimintalokiSpostiParametrit = {
        emailit: kasiteltava.email.vastaanottajat.map(vastaanottaja => {
          return vastaanottaja.email
        }),
      }
      this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SPOSTI, juurilasku, kasiteltava, batch, parametrit)

      // Lisää työjonomerkinnät
      const tyojonomerkinta: LaskuEmailtyojononMerkinta = {
        kasiteltavaAvain: kasiteltava.avain,
        laskuAvain: juurilasku.avain,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
        asiakasId: kayttajanTiedot.asiakasId,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
      }
      const tyojonoUri = this.laskuUriService.getTyojonoLaskuEmailUri(kayttajanTiedot.asiakasId, tyojonoId)
      const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojoRef, tyojonomerkinta)
    } else {
      // Mikään ei muuttunut
      return { juurilasku: juurilaskuOriginal, kasiteltava: kasiteltavaOriginal }
    }

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async merkitseLaskunMaksumuistutusLahetetyksiSahkoisesti(
    kayttajanTiedot: KayttajanTiedot,
    osoite: LaskunSahkoinenOsoite,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    batchManipulator?: BatchManipulator,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    // Sanitization:
    kasiteltava.email = null
    kasiteltava.print = null

    // Asetetaan käsiteltävä lukkoon, jotta sitä ei voi enää muokata
    kasiteltava.lukossa = true
    kasiteltava.sahkoinen = {
      done: null,
      start: this.timestampService.now(),
      osoite: osoite,
      status: LaskuSahkoinenLahetysStatusKoodi.PROSESSOIDAAN,
    }
    kasiteltava.asiakas.sahkoinenosoite = osoite

    this.paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava, LaskunLahetystapa.SAHKOINEN)

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuSahkoinenlUri(kayttajanTiedot.asiakasId, tyojonoId)
    const batch = this.firestoreProvider.annaUusiBatch()

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // console.log(kasiteltava.print.start, typeof kasiteltava.print.start, kasiteltava.print.start.constructor.name)

    // Aseta tila
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää batchiin asiakas
    this.lisaaLaskunAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
    this._poistaRekisterivalinnatRiveilta(kasiteltava)

    // Lisää lokimerkinnät
    const parametrit: LaskunToimintalokiSahkoinenParametrit = {
      osoite: kasiteltava.sahkoinen.osoite,
    }
    const luontiTyyppi = juurilasku.avain === kasiteltava.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, luontiTyyppi, juurilasku, kasiteltava, batch)
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_MAKSUMUISTUTUS_SAHKOINEN, juurilasku, kasiteltava, batch, parametrit)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuSahkoinentyojononMerkinta = {
      laskuAvain: juurilasku.avain,
      kasiteltavaAvain: kasiteltava.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    if (ostavanAsiakkaanAvain) {
      tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
    }
    const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojonomerkintaUri, tyojonomerkinta)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    // if (juurilasku.print && juurilasku.print.start) {
    //   console.log(juurilasku.print.start, typeof juurilasku.print.start, juurilasku.print.start.constructor.name)
    // }

    if (batchManipulator) {
      batchManipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava: LaskuBase, lahetystapa: LaskunLahetystapa) {
    const tuotteetTallennetaanRekisteriin = kasiteltava.nrotyyppi !== LaskunumeroTyyppi.HYVITYS
    // Päivitä asiakkaan tuotteet
    for (const laskunTuote of kasiteltava.tuotteet) {
      if (
        tuotteetTallennetaanRekisteriin &&
        laskunTuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU &&
        laskunTuote.tuote.avain !== TuoteAvaimet.KORKOKULU &&
        laskunTuote.tallennetaanRekisteriin !== false
      ) {
        // Aseta hinta ja id
        laskunTuote.tuote.hinta = laskunTuote.hinta
        const onUusiTuote = !laskunTuote.tuote.avain
        if (onUusiTuote) {
          laskunTuote.tuote.avain = this.firestoreProvider.annaUusiAvain()
        }
        if (!laskunTuote.tuote.valuutta) {
          laskunTuote.tuote.valuutta = kasiteltava.valuutta
        }
      }
    }
    // Päivitä laskun asiakas
    kasiteltava.asiakas.avain = kasiteltava.asiakas.avain ? kasiteltava.asiakas.avain : this.firestoreProvider.annaUusiAvain()
    kasiteltava.asiakas.viimeisinLaskuLahetetty = lahetystapa
  }

  private _poistaRekisterivalinnatRiveilta(kasiteltava: LaskuBase) {
    for (const laskunTuote of kasiteltava.tuotteet) {
      delete laskunTuote.tallennetaanRekisteriin
    }
  }

  lisaaTuotteetJaAsiakasBatchiin(asiakasId: string, asiakasAvain: string, kasiteltava: LaskuBase, batch: FirestoreWriteBatch) {
    const onkoHyvitys = kasiteltava.nrotyyppi === LaskunumeroTyyppi.HYVITYS
    if (onkoHyvitys) {
      this.lisaaLaskunAsiakasBatchiin(asiakasId, asiakasAvain, kasiteltava, batch)
      return
    }
    // Päivitä asiakkaan tuotteet
    for (const laskunTuote of kasiteltava.tuotteet) {
      const onkoValuutatonRekisterituote = this._onkoValuutatonRekisterituote(laskunTuote)
      if (laskunTuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && laskunTuote.tuote.avain !== TuoteAvaimet.KORKOKULU && laskunTuote.tallennetaanRekisteriin !== false) {
        // Muunna asiakkaan tuotteeksi ja lisää batchiin
        const asiakkaanTuote = this.laskuKopioija.teeAsiakkaanTuoteLaskuntuotteesta(laskunTuote)
        if (!asiakkaanTuote.alv) {
          asiakkaanTuote.alv = {}
        }
        asiakkaanTuote.alv[kasiteltava.tyyppi] = laskunTuote.alv.tunniste
        this._taydennaTuotteenKotimaanAlv(asiakkaanTuote, kasiteltava)
        this.lisaaTuoteBatchiin(asiakasId, asiakasAvain, asiakkaanTuote, batch)
      } else if (onkoValuutatonRekisterituote) {
        this._lisaaRekisterituotteenValuuttaBatchiin(asiakasAvain, laskunTuote.tuote.avain, kasiteltava.valuutta, batch)
      }
    }
    this.lisaaLaskunAsiakasBatchiin(asiakasId, asiakasAvain, kasiteltava, batch)
  }

  lisaaLaskunAsiakasBatchiin(asiakasId: string, asiakasAvain: string, kasiteltava: LaskuBase, batch: FirestoreWriteBatch) {
    const asiakas = this.laskuKopioija.copyAsiakas(kasiteltava.asiakas)
    asiakas.laskunKieli = kasiteltava.kieli
    asiakas.laskunTyyppi = asiakas.laskunTyyppi || kasiteltava.tyyppi
    asiakas.laskunValuutta = asiakas.laskunValuutta || kasiteltava.valuutta
    this.lisaaAsiakasBatchiin(asiakasId, asiakasAvain, asiakas, batch)
  }

  private _taydennaTuotteenKotimaanAlv(asiakkaanTuote: AsiakkaanTuote, kasiteltava: LaskuBase) {
    const kotimaanAlvPuuttuu = !asiakkaanTuote.alv[LaskunTyypit.TAVALLINEN.avain]
    const rivinAlvLukittuNollaan = this._onkoRivinAlvLukittuNollaan(kasiteltava)
    if (kotimaanAlvPuuttuu && rivinAlvLukittuNollaan) {
      asiakkaanTuote.alv[LaskunTyypit.TAVALLINEN.avain] = 'suomi255'
    }
  }

  private _onkoRivinAlvLukittuNollaan(kasiteltava: LaskuBase): boolean {
    return ALV_NOLLAAN_LUKITUT_LAJIT.includes(kasiteltava.tyyppi)
  }

  private _onkoValuutatonRekisterituote(laskunTuote: LaskunTuote): boolean {
    const onkoErikoisrivi = laskunTuote.tuote.avain === TuoteAvaimet.HUOMAUTUSKULU || laskunTuote.tuote.avain === TuoteAvaimet.KORKOKULU
    return !onkoErikoisrivi && !!laskunTuote.tuote.avain && !laskunTuote.tuote.valuutta
  }

  private _lisaaRekisterituotteenValuuttaBatchiin(asiakasAvain: string, tuoteAvain: string, valuutta: string, batch: FirestoreWriteBatch) {
    const options: SetOptions = { merge: true }

    const tuoteRef = this.firestoreProvider.annaDoc(this.laskuUriService.getLaskuTuoteUri(asiakasAvain, tuoteAvain))
    batch.set(tuoteRef, { valuutta }, options)

    const typeaheadRef = this.firestoreProvider.annaDoc(this.laskuUriService.getTypeaheadTuoteDokumentinUriNew(asiakasAvain))
    batch.set(typeaheadRef, { [tuoteAvain]: { valuutta } }, options)
  }

  async merkitseLaskunMaksumuistutusLahetetyksiTulostamalla(
    kayttajanTiedot: KayttajanTiedot,
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    reskontra: LaskuReskontra[],
    batchManipulator?: BatchManipulator,
    ostavanAsiakkaanAvain?: string,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    // Sanitization:
    kasiteltava.email = null
    kasiteltava.sahkoinen = null

    // Asetetaan käsiteltävä lukkoon, jotta sitä ei voi enää muokata
    kasiteltava.lukossa = true
    kasiteltava.print = {
      done: null,
      start: this.timestampService.now(),
    }

    this.paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava, LaskunLahetystapa.ITSE)

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    // Luo urit
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuTulostusUri(kayttajanTiedot.asiakasId, tyojonoId)
    const batch = this.firestoreProvider.annaUusiBatch()

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Aseta tila
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää batchiin asiakas
    this.lisaaLaskunAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
    this._poistaRekisterivalinnatRiveilta(kasiteltava)

    // Lisää lokimerkinnät
    const luontiTyyppi = juurilasku.avain === kasiteltava.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, luontiTyyppi, juurilasku, kasiteltava, batch)
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_MAKSUMUISTUTUS_TULOSTA, juurilasku, kasiteltava, batch)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuTulostamistyojononMerkinta = {
      laskuAvain: juurilasku.avain,
      kasiteltavaAvain: kasiteltava.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    if (ostavanAsiakkaanAvain) {
      tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
    }
    const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojoRef, tyojonomerkinta)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    if (batchManipulator) {
      batchManipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async merkitseLaskunMaksumuistutusLahetetyksiSpostilla(params: MaksumuistutusSpostiParametrit): Promise<JuurilaskuJaKasiteltava> {
    const {
      kayttajanTiedot,
      templateId,
      juurilaskuOriginal,
      kasiteltavaOriginal,
      reskontra,
      vastaanottajat,
      aihe,
      otsikko,
      teksti,
      slogan,
      paivitaLahettajatAsiakkaaseen,
      batchManipulator,
      ostavanAsiakkaanAvain,
      allekirjoitusHtml,
    } = params
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    // Sanitization:
    kasiteltava.print = null
    kasiteltava.sahkoinen = null

    // Asetetaan käsiteltävä lukkoon, jotta sitä ei voi enää muokata
    kasiteltava.lukossa = true

    // Asetetaan email tiedot:
    kasiteltava.email = {
      start: this.timestampService.now(),
      done: null,
      aihe: aihe,
      otsikko: otsikko,
      teksti: teksti,
      slogan: slogan,
      template: templateId,
      vastaanottajat: vastaanottajat,
    }

    if (allekirjoitusHtml) {
      kasiteltava.email.allekirjoitusHtml = allekirjoitusHtml
    }

    if (paivitaLahettajatAsiakkaaseen) {
      kasiteltava.asiakas.laskunVastaanottajat = vastaanottajat.map(vastaanottaja => {
        return vastaanottaja.email
      })
    }

    this.paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava, LaskunLahetystapa.SAHKOPOSTI)

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    // Luo urit
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuEmailUri(kayttajanTiedot.asiakasId, tyojonoId)
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Aseta tila
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää batchiin asiakas
    this.lisaaLaskunAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
    this._poistaRekisterivalinnatRiveilta(kasiteltava)

    // Lisää lokimerkinnät
    const luontiTyyppi = juurilasku.avain === kasiteltava.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, luontiTyyppi, juurilasku, kasiteltava, batch)
    const parametrit: LaskunToimintalokiSpostiParametrit = {
      emailit: vastaanottajat.map(vastaanottaja => {
        return vastaanottaja.email
      }),
    }
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_MAKSUMUISTUTUS_SPOSTI, juurilasku, kasiteltava, batch, parametrit)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuEmailtyojononMerkinta = {
      kasiteltavaAvain: kasiteltava.avain,
      laskuAvain: juurilasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    if (ostavanAsiakkaanAvain) {
      tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
    }
    const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojoRef, tyojonomerkinta)

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    if (batchManipulator) {
      batchManipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async lahetaUudelleenSpostilla(params: LahetaUudelleenSpostillaParametrit): Promise<JuurilaskuJaKasiteltava> {
    const { kayttajanTiedot, templateId, juurilaskuOriginal, kasiteltavaOriginal, reskontra, vastaanottajat, aihe, otsikko, teksti, slogan, ostavanAsiakkaanAvain } = params
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    kasiteltava.email = {
      start: this.timestampService.now(),
      done: null,
      aihe: aihe,
      otsikko: otsikko,
      teksti: teksti,
      slogan: slogan,
      template: templateId,
      vastaanottajat: vastaanottajat,
    }
    collector.addChangePath(juurilasku, kasiteltava, 'email', kasiteltava.email)

    const laskunAsiakas = kasiteltava.asiakas
    laskunAsiakas.viimeisinLaskuLahetetty = LaskunLahetystapa.SAHKOPOSTI
    collector.addChange(juurilasku, kasiteltava, 'asiakas', laskunAsiakas)

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    const parametrit: LaskunToimintalokiSpostiParametrit = {
      emailit: vastaanottajat.map(vastaanottaja => vastaanottaja.email),
    }
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SPOSTI, juurilasku, kasiteltava, batch, parametrit)

    const tyojonomerkinta: LaskuEmailtyojononMerkinta = {
      kasiteltavaAvain: kasiteltava.avain,
      laskuAvain: juurilasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    if (ostavanAsiakkaanAvain) {
      tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
    }
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuEmailUri(kayttajanTiedot.asiakasId, tyojonoId)
    const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojoRef, tyojonomerkinta)

    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    this.lisaaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, laskunAsiakas, batch)

    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async lahetaUudelleenSahkoisesti(params: LahetaUudelleenSahkoisestiParametrit): Promise<JuurilaskuJaKasiteltava> {
    const { kayttajanTiedot, osoite, juurilaskuOriginal, kasiteltavaOriginal, reskontra, ostavanAsiakkaanAvain } = params
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    kasiteltava.sahkoinen = {
      done: null,
      start: this.timestampService.now(),
      osoite: osoite,
      status: LaskuSahkoinenLahetysStatusKoodi.PROSESSOIDAAN,
    }
    collector.addChangePath(juurilasku, kasiteltava, 'sahkoinen', kasiteltava.sahkoinen)

    const laskunAsiakas = kasiteltava.asiakas
    laskunAsiakas.viimeisinLaskuLahetetty = LaskunLahetystapa.SAHKOINEN
    collector.addChange(juurilasku, kasiteltava, 'asiakas', laskunAsiakas)

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    const parametrit: LaskunToimintalokiSahkoinenParametrit = {
      osoite: osoite,
    }
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SAHKOINEN, juurilasku, kasiteltava, batch, parametrit)

    const tyojonomerkinta: LaskuSahkoinentyojononMerkinta = {
      laskuAvain: juurilasku.avain,
      kasiteltavaAvain: kasiteltava.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    if (ostavanAsiakkaanAvain) {
      tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
    }
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuSahkoinenlUri(kayttajanTiedot.asiakasId, tyojonoId)
    const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojonomerkintaUri, tyojonomerkinta)

    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    this.lisaaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, laskunAsiakas, batch)

    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async lahetaUudelleenTulostamalla(params: LahetaUudelleenTulostamallaParametrit): Promise<JuurilaskuJaKasiteltava> {
    const { kayttajanTiedot, juurilaskuOriginal, kasiteltavaOriginal, reskontra, ostavanAsiakkaanAvain } = params
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    kasiteltava.print = {
      done: null,
      start: this.timestampService.now(),
    }
    collector.addChangePath(juurilasku, kasiteltava, 'print', kasiteltava.print)

    const laskunAsiakas = kasiteltava.asiakas
    laskunAsiakas.viimeisinLaskuLahetetty = LaskunLahetystapa.ITSE
    collector.addChange(juurilasku, kasiteltava, 'asiakas', laskunAsiakas)

    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_TULOSTA, juurilasku, kasiteltava, batch)

    const tyojonomerkinta: LaskuTulostamistyojononMerkinta = {
      laskuAvain: juurilasku.avain,
      kasiteltavaAvain: kasiteltava.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    if (ostavanAsiakkaanAvain) {
      tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
    }
    const tyojonoUri = this.laskuUriService.getTyojonoLaskuTulostusUri(kayttajanTiedot.asiakasId, tyojonoId)
    const tyojonomerkintaUri = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojonomerkintaUri, tyojonomerkinta)

    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    this.lisaaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, laskunAsiakas, batch)

    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async merkitseLaskuLahetetyksiSpostilla(params: LaskuSpostiParametrit): Promise<JuurilaskuJaKasiteltava> {
    const {
      kayttajanTiedot,
      templateId,
      juurilaskuOriginal,
      kasiteltavaOriginal,
      reskontra,
      vastaanottajat,
      aihe,
      otsikko,
      teksti,
      slogan,
      tasapainoitaEnsinKayttaenViitenumeroa,
      manipulator,
      varit,
      footer,
      logoInFooter,
      lisahuomautus,
      ostavanAsiakkaanAvain,
    } = params
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Poista spesiaalit nollarivit
    kasiteltava.tuotteet = kasiteltava.tuotteet.filter(tuote => {
      return (tuote.tuote.avain !== TuoteAvaimet.HUOMAUTUSKULU && tuote.tuote.avain !== TuoteAvaimet.KORKOKULU) || Math.floor(tuote.hinta * 100) !== 0
    })

    // Sanitization:
    kasiteltava.print = null
    kasiteltava.sahkoinen = null

    // Asetetaan käsiteltävä lukkoon, jotta sitä ei voi enää muokata
    kasiteltava.lukossa = true

    // Asetetaan email tiedot:
    kasiteltava.email = {
      start: this.timestampService.now(),
      done: null,
      aihe: aihe,
      otsikko: otsikko,
      teksti: teksti,
      slogan: slogan,
      template: templateId,
      vastaanottajat: vastaanottajat,
    }

    if (varit !== undefined) {
      kasiteltava.email.vari = varit
    }

    if (footer !== undefined) {
      kasiteltava.email.footer = footer
    }

    if (logoInFooter !== undefined) {
      kasiteltava.email.logoInFooter = logoInFooter
    }

    if (lisahuomautus !== undefined) {
      kasiteltava.email.lisahuomautus = lisahuomautus
    }

    this.paivitaTuotteidenJaAsiakkaanAvaimet(kasiteltava, LaskunLahetystapa.SAHKOPOSTI)

    kasiteltava.asiakas.laskunVastaanottajat = vastaanottajat.map(vastaanottaja => {
      return vastaanottaja.email
    })

    if (juurilasku.avain === kasiteltava.avain) {
      collector.setJuurilaskuAsTheChange(juurilasku)
    } else {
      collector.setKasiteltavaAsTheChange(kasiteltava)
    }

    // Luo urit
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    this._lisaaKateislaskunSuoritusReskontraan(kayttajanTiedot, juurilasku, kasiteltava, reskontra, batch)

    // Päivitä summat
    this.shared.paivitaRyppaanJaKasiteltavanSummat(juurilasku, kasiteltava, reskontra, collector)

    // Aseta tila
    this.shared.paivitaLaskunTila(juurilasku, reskontra, collector)

    // Lisää batchiin tuotteet ja asiakas
    this.lisaaTuotteetJaAsiakasBatchiin(kayttajanTiedot.asiakasId, kayttajanTiedot.asiakasAvain, kasiteltava, batch)
    this._poistaRekisterivalinnatRiveilta(kasiteltava)

    // Lisää lokimerkinnät
    const luontiTyyppi = juurilasku.avain === kasiteltava.avain ? LaskunToimintalokiTyyppi.LUOTU : LaskunToimintalokiTyyppi.MUOKATTU
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, luontiTyyppi, juurilasku, kasiteltava, batch)
    const parametrit: LaskunToimintalokiSpostiParametrit = {
      emailit: vastaanottajat.map(vastaanottaja => {
        return vastaanottaja.email
      }),
    }
    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.LAHETETTY_SPOSTI, juurilasku, kasiteltava, batch, parametrit)

    this._tiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessa(kayttajanTiedot, juurilasku, kasiteltava, batch, collector)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    if (tasapainoitaEnsinKayttaenViitenumeroa) {
      const tyojonomerkinta: LaskuTasapainoitaJaLahetaTyojonomerkinta = {
        kanava: LaskunLahetystapa.SAHKOPOSTI,
        viitenumero: tasapainoitaEnsinKayttaenViitenumeroa,
        kasiteltavaAvain: kasiteltava.avain,
        laskuAvain: juurilasku.avain,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
        asiakasId: kayttajanTiedot.asiakasId,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
      }
      if (ostavanAsiakkaanAvain) {
        tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
      }
      const tyojonoUri = this.laskuUriService.getTyojonoLaskuTasapainoitaJaLahetaUri(kayttajanTiedot.asiakasId, tyojonoId)
      const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojoRef, tyojonomerkinta)
    } else {
      const tyojonomerkinta: LaskuEmailtyojononMerkinta = {
        kasiteltavaAvain: kasiteltava.avain,
        laskuAvain: juurilasku.avain,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
        asiakasId: kayttajanTiedot.asiakasId,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
      }
      if (ostavanAsiakkaanAvain) {
        tyojonomerkinta.ostavanAsiakkaanAvain = ostavanAsiakkaanAvain
      }
      const tyojonoUri = this.laskuUriService.getTyojonoLaskuEmailUri(kayttajanTiedot.asiakasId, tyojonoId)
      const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojoRef, tyojonomerkinta)
    }

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    if (manipulator) {
      manipulator.manipulate(this.firestoreProvider, batch, juurilasku, kasiteltava)
    }

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async merkitseLaskunPerintaLahetetyksiSpostilla(
    kayttajanTiedot: KayttajanTiedot,
    reskontra: LaskuReskontra[],
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
  ): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, kasiteltavaOriginal, kayttajanTiedot)

    // Luo urit
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const tyojonoUri = this.laskuUriService.getTyojonoPerintaLaskuEmailUri(kayttajanTiedot.asiakasId, tyojonoId)
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    // Merkitse siirretyksi perintään
    juurilasku.perintatiedot = {
      lahetettyPeruutusFrontend: null,
      lahetettyPeruutus: null,
      lahetettyFrontend: this.timestampService.now(),
      lahetetty: null,
      lahetykset: null,
      vastaanottaja: null, // Ei vielä lähetetty oikeasti.
      status: 'ok',
      success: 'Save on frontend',
    }
    collector.addJuurilaskuChange('perintatiedot', juurilasku.perintatiedot)

    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.PERINTA_LAHETETTY, juurilasku, juurilasku, batch)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuPerintaEmailtyojononMerkinta = {
      kasiteltavaAvain: juurilasku.avain,
      laskuAvain: juurilasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      kayttajaAvain: kayttajanTiedot.uid,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojoRef, tyojonomerkinta)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  async merkitseLaskunPerintaPerutuksiSpostilla(kayttajanTiedot: KayttajanTiedot, reskontra: LaskuReskontra[], juurilaskuOriginal: Lasku): Promise<JuurilaskuJaKasiteltava> {
    const { juurilasku, kasiteltava, collector } = this.annaTallennettavaKopio(juurilaskuOriginal, juurilaskuOriginal, kayttajanTiedot)

    // Luo urit
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const tyojonoUri = this.laskuUriService.getTyojonoPerintaLaskunPeruutusEmailUri(kayttajanTiedot.asiakasId, tyojonoId)
    const laskuUri = this.laskuUriService.getCustomerLaskuUri(kayttajanTiedot.asiakasAvain, juurilasku.avain)
    const batch = this.firestoreProvider.annaUusiBatch()

    juurilasku.perintatiedot.lahetettyPeruutusFrontend = this.timestampService.now()
    collector.addJuurilaskuChangePath('perintatiedot.lahetettyPeruutusFrontend', juurilasku.perintatiedot.lahetettyPeruutusFrontend)

    this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.POISTETTU_PERINNASTA, juurilasku, juurilasku, batch)

    // Prepare for save
    this.valmisteleTallennettavaksi(juurilasku, kasiteltava, reskontra, collector)

    // Tallenna lasku
    this.lisaaHistoriaMerkinta(kayttajanTiedot, juurilasku, batch)
    const laskuRef = this.firestoreProvider.annaDoc(laskuUri)
    collector.transferChangesToBatch(laskuRef, batch)

    // Tallenna tyojono
    const tyojonomerkinta: LaskuPerintaEmailtyojononMerkinta = {
      kasiteltavaAvain: juurilasku.avain,
      laskuAvain: juurilasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      kayttajaAvain: kayttajanTiedot.uid,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }

    // Tallenna Postgres työjono
    this.lisaaPostgresTyojonoBatchiin(juurilasku, kayttajanTiedot, batch)

    const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
    batch.set(tyojoRef, tyojonomerkinta)

    await batch.commit()
    this.laskuKopioija.siirraLaskuTiedot(juurilasku, juurilaskuOriginal)
    return { juurilasku, kasiteltava }
  }

  private _tiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessa(
    kayttajanTiedot: KayttajanTiedot,
    juurilasku: Lasku,
    kasiteltava: LaskuBase,
    batch: FirestoreWriteBatch,
    collector: LaskuChangeCollectorInterface,
  ): void {
    if (
      juurilasku?.perintatiedot &&
      juurilasku.perintatiedot.lahetettyFrontend &&
      kasiteltava &&
      !juurilasku.perintatiedot.lahetykset[kasiteltava.avain] &&
      !juurilasku.perintatiedot.lahetettyPeruutusFrontend
    ) {
      juurilasku.perintatiedot.lahetykset[kasiteltava.avain] = {
        kasiteltavaAvain: kasiteltava.avain,
        lahetettyFrontend: this.timestampService.now(),
        lahetetty: null,
      }
      collector.addPerintatiedotLahetysChange(kasiteltava.avain, 'kasiteltavaAvain', juurilasku.perintatiedot.lahetykset[kasiteltava.avain].kasiteltavaAvain)
      collector.addPerintatiedotLahetysChange(kasiteltava.avain, 'lahetettyFrontend', juurilasku.perintatiedot.lahetykset[kasiteltava.avain].lahetettyFrontend)
      collector.addPerintatiedotLahetysChange(kasiteltava.avain, 'lahetetty', juurilasku.perintatiedot.lahetykset[kasiteltava.avain].lahetetty)

      // Luo urit
      const tyojonoId = this.firestoreProvider.annaUusiAvain()
      const tyojonoUri = this.laskuUriService.getTyojonoTiedotaPerinnassaOlevanLaskunMuutoksestaTarvittaessaUri(kayttajanTiedot.asiakasId, tyojonoId)

      this.lisaaToimintalokiMerkinta(kayttajanTiedot, LaskunToimintalokiTyyppi.PERINTA_LAHETETTY_LISATIEDOT_HYVITYS, juurilasku, kasiteltava, batch)

      // Tallenna tyojono
      const tyojonomerkinta: LaskuPerintaEmailtyojononMerkinta = {
        kasiteltavaAvain: kasiteltava.avain,
        laskuAvain: juurilasku.avain,
        asiakasAvain: kayttajanTiedot.asiakasAvain,
        asiakasId: kayttajanTiedot.asiakasId,
        kayttajaAvain: kayttajanTiedot.uid,
        uudelleenyrityksia: 0,
        aloitettu: this.timestampService.now(),
      }

      const tyojoRef = this.firestoreProvider.annaDoc(tyojonoUri)
      batch.set(tyojoRef, tyojonomerkinta)
    }
  }

  annaTallennettavaKopio(
    juurilaskuOriginal: Lasku,
    kasiteltavaOriginal: LaskuBase,
    kayttajanTiedot: KayttajanTiedot,
    providedCollector?: LaskuChangeCollectorInterface,
  ): { juurilasku: Lasku; kasiteltava: LaskuBase; collector: LaskuChangeCollectorInterface } {
    let isNewDoc = false

    // Aseta avaimet
    if (!juurilaskuOriginal.avain || juurilaskuOriginal.avain === UUDEN_LASKUN_AVAIN) {
      juurilaskuOriginal.avain = this.firestoreProvider.annaUusiAvain()
      isNewDoc = true
    }
    if (!kasiteltavaOriginal.avain || kasiteltavaOriginal.avain === UUDEN_LASKUN_AVAIN) {
      kasiteltavaOriginal.avain = this.firestoreProvider.annaUusiAvain()
    }

    // juurilaskuOriginal.avain = juurilaskuOriginal.avain && juurilaskuOriginal.avain !== UUDEN_LASKUN_AVAIN ? juurilaskuOriginal.avain : this.firestoreProvider.annaUusiAvain()
    // kasiteltavaOriginal.avain = kasiteltavaOriginal.avain && kasiteltavaOriginal.avain !== UUDEN_LASKUN_AVAIN ? kasiteltavaOriginal.avain : this.firestoreProvider.annaUusiAvain()

    const juurilasku = this.laskuKopioija.copyLasku(juurilaskuOriginal)
    const kasiteltava = this.shared.annaKasiteltavaLasku(juurilasku, kasiteltavaOriginal.avain)

    const collector = providedCollector ?? new LaskuChangeCollector(isNewDoc ? 'new-document' : 'existing-document')

    // Tämä normalisoi viitenumeron hakuja varten
    if (juurilasku.viitenumero) {
      const muotoiltu = this.viitenumeroService.muotoileViitenumero(juurilasku.viitenumero) // Poistaa etunollat jne.
      const whitespacePoistettu = this.stringService.removeAllWhiteSpaces(muotoiltu)
      if (whitespacePoistettu) {
        if (juurilasku.viitenumero !== whitespacePoistettu) {
          collector.addJuurilaskuChange('viitenumero', whitespacePoistettu)
        }
        juurilasku.viitenumero = whitespacePoistettu
      } else {
        throw new Error('Viitenumero ' + juurilasku.viitenumero + ' katosi!')
      }
    }

    this.asetaLahettajanJaPaivittajanTiedot(kayttajanTiedot, juurilasku, kasiteltava, collector)

    if (!juurilasku.lahetystyyppi) {
      juurilasku.lahetystyyppi = LaskunLahetystyyppi.KERTA
      collector.addJuurilaskuChange('lahetystyyppi', juurilasku.lahetystyyppi)
    }
    return { juurilasku, kasiteltava, collector }
  }

  valmisteleTallennettavaksi(juurilasku: Lasku, kasiteltava: LaskuBase, reskontra: LaskuReskontra[], collector: LaskuChangeCollectorInterface) {
    juurilasku['haku'] = this.laskuIndeksoija.luoHakutiedotLaskulle(juurilasku, kasiteltava, reskontra)
    collector.addHakuChange(juurilasku['haku'])

    juurilasku.listauksessa = this.shared.naytetaankoListauksessa(juurilasku)
    collector.addJuurilaskuChange('listauksessa', juurilasku.listauksessa)
  }

  lisaaPostgresTyojonoBatchiin(lasku: Lasku, kayttajanTiedot: Pick<KayttajanTiedot, 'asiakasAvain' | 'asiakasId'>, batch: FirestoreWriteBatch): void {
    if (lasku.omitFromStatistics) {
      return
    }

    const tyojonoData: LaskuPostgresTyojonoData = {
      laskuAvain: lasku.avain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
      aloitettu: this.timestampService.now(),
    }
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const bqTyojonoDoc = this.firestoreProvider.annaDoc(this.laskuUriService.getTyojonoLaskuPostgresUri(kayttajanTiedot.asiakasAvain, tyojonoId))
    batch.set(bqTyojonoDoc, tyojonoData)
  }

  lisaaHakuindeksiTyojonoBatchiin(lasku: Lasku, kayttajanTiedot: Pick<KayttajanTiedot, 'asiakasAvain' | 'asiakasId'>, batch: FirestoreBatchOrTransaction): void {
    const merkinta: LaskuHakuindeksiTyojonoMerkinta = {
      tyyppi: 'muutos',
      laskuAvain: lasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      luotu: this.timestampService.now(),
    }
    const tyojonoId = this.firestoreProvider.annaUusiAvain()
    const tyojonoDoc = this.firestoreProvider.annaDoc(this.laskuUriService.getLaskuHakuindeksinTyojonoUri(kayttajanTiedot.asiakasId, tyojonoId))
    batch.set(tyojonoDoc, merkinta)
  }

  lisaaLemonatoriinVientiTyojonoBatchiin(juurilasku: Lasku, kasiteltava: LaskuBase, kayttajanTiedot: KayttajanTiedot, batch: FirestoreWriteBatch): void {
    const uudenMerkinnanTiedot: LaskuVientiLemonatoriintyojononMerkinta = {
      aloitettu: this.timestampService.now(),
      lahetaSlack: false,
      kasiteltavaAvain: kasiteltava.avain,
      laskuAvain: juurilasku.avain,
      asiakasAvain: kayttajanTiedot.asiakasAvain,
      asiakasId: kayttajanTiedot.asiakasId,
      uudelleenyrityksia: 0,
    }
    const lemonatoriinAvain = this.firestoreProvider.annaUusiAvain()
    const lemonatoriinUri = this.laskuUriService.getTyojonoLaskuVientiLemonatoriinUri(kayttajanTiedot.asiakasId, lemonatoriinAvain)
    const lemonatoriinDoc = this.firestoreProvider.annaDoc(lemonatoriinUri)
    batch.set(lemonatoriinDoc, uudenMerkinnanTiedot)
  }
}
